var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import UserService from '../../api/UserService';
import { Loading } from 'element-ui';
var RecordDialog = (function (_super) {
    __extends(RecordDialog, _super);
    function RecordDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.tableHeight = 500;
        _this.row = null;
        _this.formData = {
            s_time: new Date((new Date().getTime() / 1000 - 6 * 86400) * 1000).format("yyyy-MM-dd"),
            e_time: new Date().format("yyyy-MM-dd")
        };
        return _this;
    }
    RecordDialog.prototype.created = function () {
        this.service = UserService.getInstance();
        this.getLists();
    };
    RecordDialog.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.$el && _this.$el.parentElement) {
                _this.tableHeight = _this.$el.parentElement.clientHeight - 140;
            }
        }, 300);
    };
    RecordDialog.prototype.getLists = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        if ((new Date(this.formData.e_time).getTime() - new Date(this.formData.s_time).getTime()) > 30 * 24 * 60 * 60 * 1000) {
            this.$message.error('查询日期不能超过30天！');
            return;
        }
        var params = {
            account_id: this.row.account_id
        };
        Object.assign(params, pager, this.formData);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getRecordList(params).then(function (res) {
            loadingInstance.close();
            _this.listData = res.data.data;
            _this.total = res.data.total;
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    RecordDialog.prototype.search = function () {
        this.$refs.pagination.clear();
        this.getLists();
    };
    RecordDialog.prototype.pageChange = function (pager) {
        this.getLists(pager);
    };
    RecordDialog = __decorate([
        Component
    ], RecordDialog);
    return RecordDialog;
}(Vue));
export default RecordDialog;
